// BannerInformationTab.js
import React from "react";
import Tooltip from "@mui/material/Tooltip";
import RefreshIcon from "../../images/refreshNew.svg";
import CopyImage from "../../images/CopyImage.svg";
import lockCircled from "../../images/lockCircled.svg";
import { getStatusIcon } from "../../Uitls/Util";
import { toast } from "react-toastify";

import {
  getOrDash,
  hasRealValue,
  formatDateTime,
  joinSizes,
} from "../../Uitls/DetailsHelpers";
import Row from "./DetailsRow";

function BannerInformationTab({
  bannerDetails = {},
  recentlyViewedData = {},
  onRefreshMLR,
  currentSize,
}) {
  const normalizeSize = (v) => {
    if (!v) return "";
    const str = String(v).toLowerCase().trim();
    const match = str.match(/(\d+)\s*[x×*]\s*(\d+)/i);
    return match ? `${match[1]}x${match[2]}` : str;
  };

  const rawSizes = Array.isArray(bannerDetails?.sizes)
    ? [...bannerDetails.sizes]
    : [];

  let orderedSizes = rawSizes;

  if (currentSize && rawSizes.length) {
    const target = normalizeSize(currentSize);

    const idx = rawSizes.findIndex((s) => normalizeSize(s) === target);

    if (idx > 0) {
      const clone = [...rawSizes];
      const [match] = clone.splice(idx, 1);
      orderedSizes = [match, ...clone];
    }
  }

  const sizes = joinSizes(orderedSizes);
  const linkToBanner = `${window.location.origin}/banner-editor/${recentlyViewedData?.id}`;
  const promomatsDocId = bannerDetails?.veevaDocNumber;

  const isUnlocked =
    recentlyViewedData?.madeBy === "me" ||
    recentlyViewedData?.lockStatus === "Unlocked";

  const reviewStatus =
    bannerDetails?.reviewStatus ||
    recentlyViewedData?.mlrStatus ||
    "Not Submitted";

  const hasDocId = hasRealValue(promomatsDocId);
  const copyLinkToClipboard = (textToCopy) => {
    (async () => {
      try {
        await navigator.clipboard.writeText(textToCopy);
        toast.success(
          <div className="notificationText">Successfully copied the link</div>,
        );
      } catch (err) {
        toast.error(
          <div className="notificationText">
            Failed to copy — please try again
          </div>,
        );
      }
    })();
  };
  const typeValue =
    typeof bannerDetails?.isAnimated === "boolean"
      ? bannerDetails.isAnimated
        ? "Animated"
        : "Static"
      : getOrDash(null);

  return (
    <div className="tab-pane-wrap banner-info-tab">
      {/* PromoMats Doc ID */}
      <div className="kv-row">
        <div className="kv-label">PromoMats Doc ID:</div>
        <div className="kv-value kv-docid">
          {hasDocId ? (
            <>
              <Tooltip title={reviewStatus}>
                <img
                  src={getStatusIcon(reviewStatus)}
                  alt="Status Icon"
                  className="status-icon-doc"
                  width={12}
                  height={12}
                />
              </Tooltip>
              <span className="doc-link">{getOrDash(promomatsDocId)}</span>
              <img
                src={RefreshIcon}
                alt=""
                className="refreshIcondetails"
                onClick={() => onRefreshMLR(promomatsDocId, "reviewStatus")}
                title="Refresh"
              />
            </>
          ) : (
            <span>{getOrDash(null)}</span>
          )}
        </div>
      </div>

      <Row label="Name:" value={getOrDash(bannerDetails?.assetName)} />
      <Row label="Type:" value={typeValue} />
      <Row label="Size:" value={sizes} />
      <Row label="Product:" value={getOrDash(bannerDetails?.brandName)} />
      <Row label="Country:" value={getOrDash(bannerDetails?.marketName)} />

      {/* Link */}
      <div className="kv-row">
        <div className="kv-label">Link:</div>
        {isUnlocked ? (
          <div className="kv-value kv-link d-flex">
            <img
              src={CopyImage}
              alt=""
              className="icon-copy"
              title="Copy link"
              onClick={(e) => copyLinkToClipboard(linkToBanner)}
            />
            <Tooltip title={linkToBanner} placement="top">
              <a href={linkToBanner} target="_blank" rel="noreferrer">
                {linkToBanner}
              </a>
            </Tooltip>
          </div>
        ) : (
          <div className="kv-value kv-link lockedlink">
            <Tooltip title={linkToBanner} placement="top">
              <div className="banenrLink">{linkToBanner}</div>
            </Tooltip>
            <div className="d-flex locknote">
              <img src={lockCircled} alt="" />
              <span className="lockmessage">Banner is locked</span>
            </div>
          </div>
        )}
      </div>

      {/* RSD Block */}
      <div className="rsd-block">
        <div className="kv-row">
          <div className="kv-label">PromoMats RSD Doc ID:</div>
          <div className="kv-value kv-docid">
            {hasDocId ? (
              <>
                <Tooltip title={reviewStatus}>
                  <img
                    src={getStatusIcon(reviewStatus)}
                    alt="Status Icon"
                    className="status-icon-doc"
                    width={12}
                    height={12}
                  />
                </Tooltip>
                <span className="doc-link">{getOrDash(promomatsDocId)}</span>
                <img
                  src={RefreshIcon}
                  alt=""
                  className="refreshIcondetails"
                  onClick={() => onRefreshMLR(promomatsDocId, "reviewStatus")}
                  title="Refresh"
                />
              </>
            ) : (
              <span>{getOrDash(null)}</span>
            )}
          </div>
        </div>

        <Row
          label="RSD Published on:"
          value={formatDateTime(bannerDetails?.rsdPublishedOn)}
        />
        <Row
          label="RSD Approved on:"
          value={formatDateTime(bannerDetails?.rsdApprovedOn)}
        />
      </div>
    </div>
  );
}

export default BannerInformationTab;
